import axios from 'axios';
import config from './config';

const client = axios.create({
  baseURL: config.apiUrl,
});

client.interceptors.request.use((config) => {
  return {
    ...config,
    headers: window.localStorage.jwt && window.localStorage.jwt.length ? { 'Authorization': `Bearer ${window.localStorage.jwt}`, ...config.headers } : config.headers
  }
}, (err) => Promise.reject(err));

client.interceptors.response.use(res => res, err => {
  if (err.response.status === 401) {
    window.localStorage.removeItem('jwt');
  }
  return Promise.reject(err);
})

export default client;



// WEBPACK FOOTER //
// ./src/client.js